import { render, staticRenderFns } from "./part-doctors.vue?vue&type=template&id=9e0697a0&"
import script from "./part-doctors.vue?vue&type=script&lang=js&"
export * from "./part-doctors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports